const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="7" stroke="#9CA3AF" strokeWidth="2"/>
    <path d="M20 20L17 17" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export default SearchIcon
